<!-- <div *ngIf="false" class="container_add">
  <div *ngIf="db.ismobile" class="category-head">
    <ion-text>New Stock Entry</ion-text>
    <ion-icon class="mouse" (click)="choose()" name="close-outline"></ion-icon>
  </div>
  <form *ngIf="false" class="p-10" [formGroup]='inventory_form'>
    <div class="input-item">
      <ion-label color="grey" class="input__title" position="stacked">Product</ion-label>
      <div lines="none" class="custom-input" [class.focused]="focus.product">
        <ion-select name="product" formControlName="product" (ionFocus)="focus.product = true" (ionBlur)="focus.product = false" class="form-input form-select" interface="popover" (ionChange)="value_changed($event,'product')" [value]="products.product_name">
          <ion-select-option *ngFor="let c of product_list" [value]="c.item">{{c.item}}</ion-select-option>
        </ion-select>
      </div>
      <div *ngIf="submitted && !product?.valid">
        <p class="error m-0" *ngIf="product.errors.required">Product is required</p>
      </div>
    </div>
    <div *ngIf="!isAttribute">
      <div class="input-item">
        <ion-label color="grey" class="input__title" position="stacked">qty </ion-label>
        <div lines="none" class="custom-input" [class.focused]="focus.qty">
          <ion-input name="qty" (ionFocus)="focus.qty = true" (ionBlur)="focus.qty = false" class="form-input" autofocus="true" autocomplete="false" required="true" formControlName="qty"></ion-input>
        </div>
        <div *ngIf="submitted && !qty?.valid">
          <p class="error m-0" *ngIf="qty.errors.required">qty is required</p>
        </div>
      </div>
      <div class="input-item">
        <ion-label color="grey" class="input__title" position="stacked">Amount </ion-label>
        <div lines="none" class="custom-input" [class.focused]="focus.amount">
          <ion-input name="amount" (ionFocus)="focus.amount = true" (ionBlur)="focus.amount = false" class="form-input" autofocus="true" autocomplete="false" required="true" formControlName="amount"></ion-input>
        </div>
        <div *ngIf="submitted && !amount?.valid">
          <p class="error m-0" *ngIf="amount.errors.required">Amount is required</p>
        </div>
      </div>
    </div>
    <div *ngIf="isAttribute">
      <div class="input-item">
        <ion-label color="grey" class="input__title" position="stacked">Attribute id</ion-label>
        <div lines="none" class="custom-input" [class.focused]="focus.product">
          <ion-select name="attribute_id" formControlName="attribute_id" (ionFocus)="focus.product = true" (ionBlur)="focus.product = false" class="form-input form-select" interface="popover" (ionChange)="value_changed($event,'attribute')" [value]="products.attributes_name">
            <ion-select-option *ngFor="let c of Product_attributes" [value]="c.attribute_name">{{c.attribute_name}}</ion-select-option>
          </ion-select>
        </div>
        <div *ngIf="submitted && !attribute_id?.valid">
          <p class="error m-0" *ngIf="attribute_id.errors.required">Attribute_id is required</p>
        </div>
      </div>
      <div class="input-item">
        <ion-label color="grey" class="input__title" position="stacked">Attribute Quantity </ion-label>
        <div lines="none" class="custom-input" [class.focused]="focus.attr_qty">
          <ion-input name="attr_qty" (ionFocus)="focus.attr_qty = true" (ionBlur)="focus.attr_qty = false" class="form-input" autofocus="true" autocomplete="false" required="true" formControlName="attr_qty"></ion-input>
        </div>
        <div *ngIf="submitted && !attr_qty?.valid">
          <p class="error m-0" *ngIf="attr_qty.errors.required">Attribute Quantity is required</p>
        </div>
      </div>
      <div class="input-item">
        <ion-label color="grey" class="input__title" position="stacked">Attribute Amount </ion-label>
        <div lines="none" class="custom-input" [class.focused]="focus.attr_rate">
          <ion-input name="attr_rate" (ionFocus)="focus.attr_rate = true" (ionBlur)="focus.attr_rate = false" class="form-input" autofocus="true" autocomplete="false" required="true" formControlName="attr_rate"></ion-input>
        </div>
        <div *ngIf="submitted && !attr_rate?.valid">
          <p class="error m-0" *ngIf="attr_rate.errors.required">Attribute Amount is required</p>
        </div>
      </div>
    </div>
    <div class="d__flex check_box">
      <span>
       
      </span>
      <p class="m-0 agree"> Is Attribute</p>
    </div>
  </form>
  <div class="inventor_transfer">
    <div class="box_2 box_sytle">
    
      <div class="__header">
        <div *ngIf="!scanner" class="search">
          <app-search-products class="searchbar"></app-search-products>
          <div class="button__">
            
            <ion-button fill="clear" (click)="scan()"><span class="span">
                <ion-icon src="/assets/icon/scan.svg"></ion-icon>
              </span>Start scan button</ion-button>
          </div>
        </div>
        <div *ngIf="scanner && false" class="scan">
          <div id="scanner-container_1" class="viewport">
           
          </div>
          <div class="button__">
            <ion-button fill="clear" (click)="close_scan()"><span class="span">
                <ion-icon name="close-outline"></ion-icon>
              </span>Close Scan</ion-button>
          </div>
        </div>
      </div>
      <div *ngIf="db.selected_items.length != 0 && !db.ismobile" class="web_title">
        <div class="d__row">
          <div class="image title just-c">Product</div>
          <div class="check_box title just-c">SKU</div>
        </div>
        <div class="d__row d_row_1">
          <div class="isattr">
           
            <div class="input-item title just-c">Quantity</div>
            <div class="input-item title just-c">Amount</div>
          </div>
         
          <div class="button"></div>
        </div>
      </div>
      <div *ngIf="db.selected_items.length != 0" class="selected_items">
        <div class="web" *ngFor="let item of db.selected_items;let i=index">
          <div class="d__row">
            <div class="image">
              <ion-avatar><img [src]="db.product_img(item.image )"> </ion-avatar>
              <div class="column">
                <ion-label class="fnt-14 webkit-text " [style.--line]="1">{{item.item| titlecase}}</ion-label>
                <ion-label class="fnt-14 webkit-text " [style.--line]="1" [innerHtml]="item.attribute_html"></ion-label>
              </div>
            </div>
            <div class="d__flex check_box">
             
              <div>
                <h5 *ngIf="db.ismobile" class="m-0">SKU</h5>
                <p class="m-0 agree">{{item.sku}}</p>
              </div>
            </div>
          </div>
        
          <div class="d__row d_row_1">
            <div [class.isattr]="item.attribute_id" *ngIf="item.attribute_id">
           
              <div class="input-item">
                <div lines="none" class="custom-input">
                  <ion-input name="attr_qty" [class.focused]="focus.attr_qty" placeholder="Attribute Quantity" (ionFocus)="focus.attr_qty = true" (ionBlur)="focus.attr_qty = false" class="form-input" autofocus="true" autocomplete="false" required="true" [(ngModel)]="item.qty"></ion-input>
                </div>
                <div *ngIf="submitted && !attr_qty?.valid && false">
                  <p class="error m-0" *ngIf="attr_qty.errors.required">Attribute Quantity is required</p>
                </div>
              </div>
              <div class="input-item">
                <div lines="none" class="custom-input">
                  <ion-input [disabled]="true" [class.focused]="focus.attr_rate" name="attr_rate" placeholder="Attribute Amount" (ionFocus)="focus.attr_rate = true" (ionBlur)="focus.attr_rate = false" class="form-input" autofocus="true" autocomplete="false" required="true" [(ngModel)]="item.price"></ion-input>
                </div>
                <div *ngIf="submitted && !attr_rate?.valid && false">
                  <p class="error m-0" *ngIf="attr_rate.errors.required">Attribute Amount is required</p>
                </div>
              </div>
            </div>
            <div [class.not_isattr]="!item.attribute_id" *ngIf="!item.attribute_id">
              <div class="input-item">
                <div lines="none" class="custom-input">
                  <ion-input name="qty" placeholder="Quantity" [class.focused]="focus.qty" (ionFocus)="focus.qty = true" (ionBlur)="focus.qty = false" class="form-input" autofocus="true" autocomplete="false" required="true" [(ngModel)]="item.qty"></ion-input>
                </div>
                <div *ngIf="submitted && !qty?.valid && false">
                  <p class="error m-0" *ngIf="qty.errors.required">qty is required</p>
                </div>
              </div>
              <div class="input-item">
                <div lines="none" class="custom-input">
                  <ion-input [disabled]="true" name="amount" [class.focused]="focus.amount" placeholder="Amount" (ionFocus)="focus.amount = true" (ionBlur)="focus.amount = false" class="form-input" autofocus="true" autocomplete="false" required="true" [(ngModel)]="item.price"></ion-input>
                </div>
                <div *ngIf="submitted && !amount?.valid && false">
                  <p class="error m-0" *ngIf="amount.errors.required">Amount is required</p>
                </div>
              </div>
            </div>
           
            <div class="button_clear">
             
              <ion-button fill="claer" (click)="clear_item(i)">
                <ion-icon class="mouse" name="close-outline"></ion-icon>{{db.ismobile ? '' : 'Clear'}}
              </ion-button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="db.selected_items.length != 0" class="button">
        <ion-button fill="claer" (click)="add_insert()">Add</ion-button>
      </div>
    </div>
  </div>
</div> -->

<!-- New  -->
<div *ngIf="db.ismobile" class="category-head">
  <ion-text>New Stock Entry</ion-text>
  <ion-icon class="mouse" (click)="choose()" name="close-outline"></ion-icon>
  
</div>
<div class="container_1" [class.scan_con]="scanner">
  <div class="box_1">
    <div *ngIf="!scanner" class="content">
      <div class="image">
        <img src="assets/icon/scanner-svg.svg">
      </div>
      <div class="des">
        <p class="p_title">start scan to upload a product</p>
        <ion-button fill="clear" (click)="scan()">Start scan</ion-button>
        
        <!-- <ion-button (click)="scannerss('6121')">click1</ion-button>
        <ion-button (click)="scannerss('6064')">click2</ion-button>
        <ion-button (click)="scannerss('6140')">click3</ion-button>
        <ion-button (click)="scannerss('555')">click4</ion-button> -->

      </div>
    </div>
    <div *ngIf="scanner" class="content">
      <div *ngIf="false" class="scannner_image">
        <img src="assets/icon/scanner-image.png">
      </div>
      <div id="scanner-container_1" class="viewport">
        <!-- QuaggaJS will populate this element -->
      </div>
      <div *ngIf="false" class="button__">
        <ion-button fill="clear" (click)="close_scan()"><span class="span">
            <ion-icon name="close-outline"></ion-icon>
          </span>Close Scan</ion-button>
      </div>
    </div>
  </div>
  <div class="box_2">
    <div class="search_con">
      <h5 class="h5">Search & Add Products</h5>
      <div class="search">
        <app-search-products class="searchbar"></app-search-products>
      </div>
    </div>
    <div class="product heading">
      <div class="side_one">
        <p class="title">Product Detail</p>
      </div>
      <div class="side_two">
        <p class="title">Quantity</p>
      </div>
    </div>
    <div class="product_list">
      <div *ngFor="let item of db.selected_items;let i=index" class="product">
        <div class="side_one">
          <div class="d__row">
            <div class="image">
              <ion-avatar><img [src]="db.product_img(item.image )"> </ion-avatar>
            </div>
            <div class="column">
              <ion-label class="fnt-14 webkit-text " [style.--line]="1">{{item.item| titlecase}}</ion-label>
              <ion-label class="fnt-12 webkit-text " [style.--line]="1" [innerHtml]="item.attribute_html"></ion-label>
              <p class="m-0 fnt-12 agree"><span class="span fnt-12">SKU : </span>{{item.sku}}</p>
              <p class="m-0 fnt-12 agree"><span class="span fnt-12">Amount : </span>{{item.price}}</p>
            </div>
          </div>
        </div>
        <div class="side_two">
          <div class="qty">
            <div class="input-item">
              <div lines="none" class="custom-input">
                <ion-input name="qty" placeholder="Quantity" [class.focused]="focus.qty" (ionFocus)="focus.qty = true" type="number" (ionBlur)="focus.qty = false" class="form-input" autofocus="true" autocomplete="false" required="true" [(ngModel)]="item.qty"></ion-input>
              </div>
            </div>
            <div class="button_clear">
              <ion-button fill="claer" (click)="clear_item(i)">
                <ion-icon class="mouse" name="close-outline"></ion-icon>
              </ion-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="button">
      <ion-button *ngIf="db.selected_items.length != 0" class="clear_button" fill="claer" (click)="db.selected_items=[]">
        <ion-icon class="mouse" name="close-outline"></ion-icon>Clear All
      </ion-button>
      <ion-button *ngIf="db.selected_items.length != 0" class="update_button" fill="claer" (click)="add_insert()">Update</ion-button>
    </div>
  </div>
</div>

